import React, { useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import AOS from 'aos';

function PortfolioLink() {
  useEffect(() => {
    AOS.init({
      duration: 1200,
    });
  }, []);
  
  return (
    <Container>
      <Wrap>
        <StyledLink data-aos="zoom-in" to="/product-commercial">
          <Slot>
            <Overlay /> 
            <img src="./Category/commercial.jpg" alt="Product Commercial" />
            <h1>Product Commercial</h1>
          </Slot>
        </StyledLink>
        <StyledLink to="/real-state-video-production" data-aos="zoom-in">
          <Slot>
            <Overlay />
            <img src="./Category/estate.jpg" alt="Real Estate Video" />
            <h1>Real Estate</h1>
          </Slot>
        </StyledLink>

        <StyledLink to="/sports-video" data-aos="zoom-in">
          <Slot>
            <Overlay />
            <img src="./Category/sport.jpg" alt="Sports Video" />
            <h1>Action Sports</h1>
          </Slot>
        </StyledLink>

        <StyledLink to="/corporate-video" data-aos="zoom-in">
          <Slot>
            <Overlay />
            <img src="./Category/corporate.jpg" alt="Corporate Video" />
            <h1>Corporate</h1>
          </Slot>
        </StyledLink>

        <StyledLink to="/resort-productions" data-aos="zoom-in">
          <Slot>
            <Overlay />
            <img src="./Category/resort.jpg" alt="Resort Productions" />
            <h1>Resort Productions</h1>
          </Slot>
        </StyledLink>

        <StyledLink to="/destination-promotional" data-aos="zoom-in">
          <Slot>
            <Overlay />
            <img src="./Home/05.jpg" alt="Destination Promotional" />
            <h1>Destination Promotions</h1>
          </Slot>
        </StyledLink>

        <StyledLink to="/aerial" data-aos="zoom-in">
          <Slot>
            <Overlay />
            <img src="./Category/arial.jpg" alt="Aerial Cinematography" />
            <h1>Aerial Cinematography</h1>
          </Slot>
        </StyledLink>

        <StyledLink to="/documentary" data-aos="zoom-in">
          <Slot>
            <Overlay />
            <img src="./Category/documentaries.jpg" alt="Documentaries" />
            <h1>Documentaries</h1>
          </Slot>
        </StyledLink>
      </Wrap>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 50px 20px;

  @media only screen and (max-width: 768px) {
    padding: 30px 10px;
  }
`;

const Wrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
  max-width: 1200px;
  width: 100%;

  @media only screen and (max-width: 768px) {
    gap: 15px;
  }

  @media only screen and (max-width: 480px) {
    gap: 10px;
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  flex: 1 1 300px;
  max-width: 380px;
  display: flex;
  justify-content: center;

  @media only screen and (max-width: 480px) {
    flex: 1 1 95vw;
  }
`;

const Slot = styled.div`
  width: 100%;
  height: 250px;
  position: relative;
  transition: transform 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  overflow: hidden;
  border-radius: 15px;

  @media only screen and (max-width: 768px) {
    height: 220px;
  }

  @media only screen and (max-width: 480px) {
    height: 180px;
  }

  &:hover {
    cursor: pointer;
    transform: scale(1.03);
  }

  h1 {
    color: #fff;
    font-size: 18px;
    text-align: center;
    border-bottom: 1px solid var(--secondary-color);
    padding: 10px;
    border-radius: 0 0 15px 15px;
    margin: 0;

    @media only screen and (max-width: 768px) {
      font-size: 16px;
      padding: 8px;
    }

    @media only screen and (max-width: 480px) {
      font-size: 14px;
      padding: 6px;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 15px;
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  //background: rgba(0, 0, 0, 0.3);
  border-radius: 15px;
  pointer-events: none;
`;

export default PortfolioLink;
